<div class="header-bar">
  <h1 *ngIf="organisationTypeId == 2 || organisationTypeId == 4">Customer Orders Report</h1>
  <h1 *ngIf="organisationTypeId == 1">Engineius Orders Report</h1>
</div>
<div class="ui-g content-container">
  <div class="ui-g-12">
    <form (ngSubmit)="search()" style="width: 100%">
      <div class="ui-g filterPanel form-group">
        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.completedDateFrom.value"
              name="createDateFrom"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>Completed Date From</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.completedDateTo.value"
              name="createDateTo"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>Completed Date To</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.pickUpDateFrom.value"
              name="createDateTo"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>Pick Up Date From</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.pickUpDateTo.value"
              name="createDateTo"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>Pick Up Date To</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="ui-g-3">
            <label>Movement Type</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="taskTypes"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.type.value"
              name="type"
            ></p-dropdown>
          </div>
        </div>

        <div *ngIf="organisationTypeId == 1" class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="ui-g-3">
            <label>Customer</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="customers"
              autoWidth="false"
              [style]="{ width: '100%' }"
              filter="true"
              [(ngModel)]="filterVal.filters.customer.value"
              name="customer"
            ></p-dropdown>
          </div>
        </div>

        <div
          class="ui-g-12 ui-md-4 ui-lg-4"
          *ngIf="organisationTypeId == 2 || organisationTypeId == 4"
        >
          <div class="ui-g-3">
            <label>Department</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="departments"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.department.value"
              (onChange)="departmentChange($event)"
              name="department"
            ></p-dropdown>
          </div>
        </div>

        <div
          class="ui-g-12 ui-md-4 ui-lg-4"
          *ngIf="organisationTypeId == 2 || organisationTypeId == 4"
        >
          <div class="ui-g-3">
            <label>Team</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="teams"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.team.value"
              name="team"
            ></p-dropdown>
          </div>
        </div>

        <div
          class="ui-g-12 ui-md-4 ui-lg-4"
          *ngIf="organisationTypeId == 3 || organisationTypeId == 4"
        >
          <div class="ui-g-3">
            <label>Region</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="regions"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.region.value"
              name="region"
            ></p-dropdown>
          </div>
        </div>

        <div
          class="ui-g-12 ui-md-4 ui-lg-4"
          *ngIf="organisationTypeId == 3 || organisationTypeId == 4"
        >
          <div class="ui-g-3">
            <label>Depot</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="depots"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.depot.value"
              name="depot"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="ui-g-3">
            <label>Status</label>
          </div>
          <div class="ui-g-9">
            <p-multiSelect
              [options]="orderStatuses"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.status.value"
              name="status"
            ></p-multiSelect>
          </div>
        </div>

        <div class="ui-g-12">
          <button
            pButton
            type="button"
            label="Clear"
            class="ui-button btn-to-right"
            (click)="clearFilter(dt)"
          ></button>
          <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
        </div>
      </div>
    </form>

    <div style="overflow-y: scroll">
      <p-table
        #dt
        selectionMode="single"
        [value]="rows"
        [lazy]="true"
        [rows]="10"
        [paginator]="true"
        rowHover="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        [loading]="isLoading"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
      >
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let column of columns" style="{{ column.style }}">
              {{ column.label }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td *ngFor="let cell of item.cells">
              <span *ngIf="cell.cellType == 'date'">
                {{ moment(cell.value).format(cell.dateFormat) }}
              </span>
              <span *ngIf="cell.cellType == 'currency'">
                {{ cell.value | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </span>
              <span *ngIf="!cell.cellType">
                {{ cell.value }}
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!---- DATATABLES DEPRECATED ---
    <p-dataTabl #dt
                 selectionMode="single"
                 [value]="page.items"
                 [lazy]="true"
                 [rows]="10"
                 [responsive]="true"
                 [paginator]="true"
                 rowHover="true"
                 resizableColumns="true"
                 [totalRecords]="page.total"
                 (onLazyLoad)="onGridLazyLoad($event)"
                 [loading]="isLoading"
                 [rowsPerPageOptions]="[5,10,20]"
                 [pageLinks]="3"
                 (onSort)="changeSort($event)"
                 [scrollable]="true">

        <p-column field="orderRef" header="Ord Ref" [sortable]="true"></p-column>
        <p-column field="jobNumber" header="Job Ref" [sortable]="true"></p-column>
        <p-column field="customerName" header="Customer" *ngIf="organisationTypeId == 1"
                  [sortable]="true" [style]="{'width':'100px'}"> </p-column>
        <p-column field="department" header="Department" [sortable]="true"></p-column>
        <p-column field="team" header="Team" [sortable]="true"></p-column>
        <p-column field="supplierName" header="Supplier" [sortable]="true" [style]="{'width':'100px'}" *ngIf="organisationTypeId == 1"></p-column>
        <p-column field="dateCreated" header="Created" [sortable]="true">
            <ng-template let-col let-order="rowData" pTemplate="body">
                <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
            </ng-template>
        </p-column>
        <p-column field="lastPickUp" header="Pick Up" [sortable]="true">
            <ng-template let-col let-order="rowData" pTemplate="body">
                <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
            </ng-template>
        </p-column>
        <p-column field="lastDropOff" header="Drop Off" [sortable]="true">
            <ng-template let-col let-order="rowData" pTemplate="body">
                <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
            </ng-template>
        </p-column>
        <p-column field="movementType" header="Type" [sortable]="true">
        </p-column>
        <p-column *ngIf="organisationTypeId == 1" field="amount" header="Amount" [sortable]="true">
            <ng-template let-order="rowData" pTemplate="body">
                <span>{{ order.amount | currency:'GBP':'symbol':'1.2-2' }}</span>
            </ng-template>
        </p-column>
        <p-column field="minPrice" header="Min" [sortable]="true">
            <ng-template let-order="rowData" pTemplate="body">
                <span *ngIf="!order.isOverridePrice && order.statusId!=statusClosed">
                    {{ order.transactionMin | currency:'GBP':'symbol':'1.2-2' }}
                </span>
            </ng-template>
        </p-column>
        <p-column field="maxPrice" header="Max" [sortable]="true">
            <ng-template let-order="rowData" pTemplate="body">
                <span *ngIf="!order.isOverridePrice && order.statusId!=statusClosed">
                    {{ order.transactionMax | currency:'GBP':'symbol':'1.2-2' }}
                </span>
            </ng-template>
        </p-column>
        <p-column field="finalPrice" header="Final" [sortable]="true">
            <ng-template let-order="rowData" pTemplate="body">
                <span *ngIf="order.isOverridePrice || order.statusId==statusClosed">
                    {{ order.transactionsSum | currency:'GBP':'symbol':'1.2-2' }}
                </span>
            </ng-template>
        </p-column>
        <p-column field="status" header="Status" [sortable]="true">
        </p-column>
        <p-column field="region" header="Region"
                  *ngIf="organisationTypeId == 3 || organisationTypeId == 4">
        </p-column>
        <p-column field="depot" header="Depot"
                  *ngIf="organisationTypeId == 3 || organisationTypeId == 4">
        </p-column>
        <p-column field="costCodes" header="Cost Code" [sortable]="true">
        </p-column>
        <p-column field="tags" header="Tags" [sortable]="true">
            <ng-template let-order="rowData" pTemplate="body">
                <div *ngFor="let tag of order.tags;">{{ tag }}</div>
            </ng-template>
        </p-column>

        <p-column field="numberOfTasks" header="Number Of Tasks" [sortable]="true">
            <ng-template let-order="rowData" pTemplate="body">
                <div>{{ order.poNumber ? order.tasks.length : 0 }}</div>
            </ng-template>
        </p-column>

        <p-column field="poNumber" header="PO #" [sortable]="true">
            <ng-template let-order="rowData" pTemplate="body">
                <div>{{ order.poNumber}}</div>
            </ng-template>
        </p-column>

        <div *ngFor="let task of tasks; let i = index">
            <p-column field="pickupLatestFrom" header="Last Pick Up From Date/Time" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? row.tasks[i].pickupEarliestDateTime : '') | datex:'ddd DD MMM \'YY HH:mm' }}</div>
                </ng-template>
            </p-column>

            <p-column field="pickupLatestTo" header="Last Pick Up To Date/Time" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? row.tasks[i].pickupLatestDateTime : '') | datex:'ddd DD MMM \'YY HH:mm' }}</div>
                </ng-template>
            </p-column>

            <p-column field="postcodeFrom" header="Postcode From" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? row.tasks[i].pickupLocation.postcode : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="postcodeTo" header="Postcode To" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? row.tasks[i].dropoffLocation.postcode : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="make" header="Vehicle" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? row.tasks[i].vehicle.make + ' ' + row.tasks[i].vehicle.model : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="registrationNumber" header="Reg Plate" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? row.tasks[i].vehicle.registrationNumber : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="distance" header="Mileage" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? mapService.getMiles(row.tasks[i].distance) : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="estimateTime" header="Travel Time" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? row.tasks[i].estimateTime : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="pickupOdometer" header="Pick Up Odo" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? (row.tasks[i].pickupOdometer | number:'2.') : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="dropoffOdometer" header="Drop Off Odo" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? (row.tasks[i].dropoffOdometer | number:'2.') : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="pickupFuel" header="Pick Up Fuel" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? taskService.fuelLevelToStr(row.tasks[i].pickupFuel) : '') }}</div>
                </ng-template>
            </p-column>

            <p-column field="dropoffFuel" header="Drop Off Fuel" [style]="{'width':'100px'}" [sortable]="true">
                <ng-template let-row="rowData" pTemplate="body">
                    <div>{{ (i < row.tasks.length ? taskService.fuelLevelToStr(row.tasks[i].dropoffFuel) : '') }}</div>
                </ng-template>
            </p-column>

        </div>

    </p-dataTable>
    -->
  </div>
  <div class="ui-g-12" style="height: 40px; margin-top: 20px">
    <button
      type="button"
      pButton
      icon="fa ui-icon-file-download"
      label="Download"
      class="ui-button btn-to-right"
      (click)="downloadReport()"
      [disabled]="page.total == 0"
    ></button>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
<p-dialog
  [header]="progressBarTitle"
  [style]="{ width: '300px' }"
  position="right"
  [responsive]="true"
  modal="true"
  [(visible)]="isLoading"
  appendTo="body"
  (onHide)="cancel()"
  [closable]="false"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
  <div class="mt-4 ui-g-12">
    <button
      type="button"
      pButton
      label="Cancel"
      class="ui-button ui-button-secondary ui-g-12"
      (click)="cancel()"
    ></button>
  </div>
</p-dialog>
